import { render, staticRenderFns } from "./DownloadFiles.vue?vue&type=template&id=136a12fd"
import script from "./DownloadFiles.vue?vue&type=script&lang=js"
export * from "./DownloadFiles.vue?vue&type=script&lang=js"
import style0 from "./DownloadFiles.vue?vue&type=style&index=0&id=136a12fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports